const uniqArray = (arr: [], newItems: []) => {
  if (!Array.isArray(newItems)) throw new Error('newItems is not Array');
  if (!Array.isArray(arr)) throw new Error('arr is not Array');
  newItems.forEach((item) => {
    if (arr.indexOf(item) === -1) {
      arr.push(item);
    }
  });
  return arr;
};

// export function* cascadePromise(arrayOfPromises: []) {
//   for (let i in arrayOfPromises) {
//     yield arrayOfPromises[i];
//   }
//
//   return true;
// }
//
// function execute(generator: any, yieldValue: any) {
//
//   let next = generator.next(yieldValue);
//
//   if (!next.done) {
//     next.value.then(
//         (result: any) => execute(generator, result),
//         (err: any) => generator.throw(err)
//     );
//   } else {
//     // обработаем результат return из генератора
//     // обычно здесь вызов callback или что-то в этом духе
//     alert(next.value);
//   }
//
// }
//
// let test = [];
// test.push(new Promise((resolve) => setTimeout(() => 3, 3000)));
// test.push(new Promise((resolve) => setTimeout(() => 1, 1000)));
// test.push(new Promise((resolve) => setTimeout(() => 2, 2000)));
//
// const generator = execute(cascadePromise(test));
export default uniqArray;
